import { render, staticRenderFns } from "./dateTabCom.vue?vue&type=template&id=16741a84&scoped=true"
import script from "./dateTabCom.vue?vue&type=script&lang=js"
export * from "./dateTabCom.vue?vue&type=script&lang=js"
import style0 from "./dateTabCom.vue?vue&type=style&index=0&id=16741a84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16741a84",
  null
  
)

export default component.exports